// It's a fake i18n function, which just returns the key.
// Used for i18n plugin to recognize the strings.
import { type MessageObject } from './i18n'
import { writable } from 'svelte/store'

export function $t(id: string | MessageObject): string {
	return id.toString()
}

export const t = writable($t)
